{
  "nl": {
    "lot": {
      "attributes": {
        "end_date": "Einddatum",
        "internal_note": "Interne notitie",
        "land_register": "Kadaster",
        "name": "Naam",
        "start_date": "Startdatum",
        "surface": "Oppervlakte"
      },
      "labels": {
        "lot": "Geen lot | Eén lot | {count} loten"
      },
      "toasts": {
        "create": "Lot aangemaakt",
        "delete": "Lot verwijderd",
        "update": "Lot gewijzigd"
      },
      "validation": {
        "needName": "Verplicht veld",
        "needNumber": "Moet een getal zijn (bv. 85.5)"
      }
    }
  }
}